export default "__VITE_ASSET__BntVCsfe__"